import { useEffect, useState } from "react";
import {
  Card,
  Box,
  Typography,
  Button,
  Divider,
  Avatar,
} from "@mui/material";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import ContactLayout from "../../../../../components/contact-layout/contact-layout";

export default function DivisionDetails({
  data,
}: any) {
  const [status, setStatus] = useState(false);
  const [primaryDivisionManager, setPrimaryDivisionManager] = useState<any>();
  const [nonPrimaryDivisionManager, setNonPrimaryDivisionManager] =
    useState<any>([]);

  useEffect(() => {
    if (data) {
      setStatus(data.isActive);

      const filterPrimaryDivisionManager = data?.divisionManagers.filter(
        (divisionManager: any) => divisionManager.isPrimary === true
      );
      const filterNonPrimaryDivisionManager = data?.divisionManagers.filter(
        (divisionManager: any) => divisionManager.isPrimary === false
      );
      setPrimaryDivisionManager(filterPrimaryDivisionManager[0]);
      setNonPrimaryDivisionManager(filterNonPrimaryDivisionManager);
    }
  }, [data]);

  return (
    <>
      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Division Details</Typography>
        </Box>
        <Box className="display-name-layout">
          <Typography className="label-txt">Status</Typography>
          <Typography>{status ? "Active" : "Inactive"}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Division Name</Typography>
          <Typography>{data?.displayName}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Division Website</Typography>
          <Box display={"flex"} alignItems={"center"}>
            {data?.website ? (
              <>
                <Typography color="primary">{data?.website}</Typography>
                <Button>
                  <OpenInNewOutlinedIcon color="primary" />
                </Button>
              </>
            ) : (
              <> - </>
            )}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Division Logo</Typography>
          <Avatar
            className="user-avater"
            alt={data?.displayName}
            variant="circular"
            src={data?.logoUrl}
          />
        </Box>
      </Card>

      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Contact Details</Typography>
        </Box>
        <Box className="user-name-layout">
          <Typography className="label-txt">Division Manager</Typography>
          <Box>
            {primaryDivisionManager ? (
              <ContactLayout data={primaryDivisionManager} isPrimary={true} />
            ) : (
              <> - </>
            )}
            {nonPrimaryDivisionManager.map((divisionManager: any) => (
              <ContactLayout
                key={divisionManager.userId}
                data={divisionManager}
                isPrimary={false}
              />
            ))}
          </Box>
        </Box>
      </Card>
    </>
  );
}
